import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store"
import AppSettings from "@/settings/appSettings"

class PORTAL_TipCerereDocumentService {
  getODataStore() {
    return new ODataStore({
      url: AppSettings.API_Url_PortalHROdata + "PORTAL_TipCerereDocument",
      key: "ID",
      version: 4,
      beforeSend: (e: any) => {
        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
      }
    });
  }

  getActive(): Promise<any> {
    return http.clientPortalHROdata.get("/PORTAL_TipCerereDocument?$filter=IsActiv eq true", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  add(data: any): Promise<any> {
    return http.clientPortalHROdata.post("/PORTAL_TipCerereDocument", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  delete(id: string): Promise<any> {
    return http.clientPortalHROdata.delete(`/PORTAL_TipCerereDocument(${id})`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_TipCerereDocumentService();
